import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';

import { SharedPipesModule } from '@sd-portal/shared/pipes';
import { SharedAircraftService } from './_services';
import { AircraftProfileSelectorComponent } from './aircraft-profile-selector/aircraft-profile-selector.component';
import { AircraftChipsAutocompleteComponent } from './aircraft-chips-autocomplete/aircraft-chips-autocomplete.component';
import { CrewAcknowledgementsGridComponent } from './crew-acknowledgements-grid/crew-acknowledgements-grid.component';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatLegacyAutocompleteModule as MatAutocompleteModule } from '@angular/material/legacy-autocomplete';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { DropDownListFilterComponent } from './dropdown-list-filter/dropdownlist-filter.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { DocumentDefaultRecipient } from './document-default-recipient/document-default-recipient.component';
import { SharedUiModule } from '@sd-portal/shared/ui';

@NgModule({
  imports: [
    GridModule,
    CommonModule,
    ReactiveFormsModule.withConfig({
      warnOnNgModelWithFormControl: 'always',
      callSetDisabledState: 'whenDisabledForLegacyCode'
    }),
    SharedPipesModule,
    // material
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatChipsModule,
    MatAutocompleteModule,
    DropDownListModule,
    DropDownsModule,
    SharedUiModule
  ],
  declarations: [
    AircraftProfileSelectorComponent,
    AircraftChipsAutocompleteComponent,
    CrewAcknowledgementsGridComponent,
    DropDownListFilterComponent,
    DocumentDefaultRecipient
  ],
  exports: [
    AircraftProfileSelectorComponent,
    AircraftChipsAutocompleteComponent,
    CrewAcknowledgementsGridComponent,
    DropDownListFilterComponent,
    DocumentDefaultRecipient,
    SharedUiModule
  ],
  providers: [SharedAircraftService]
})
export class SharedAircraftModule {}
